export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-2xl font-bold mb-4">Global Career</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              외국계 회사 취업과 경력 개발을 위한 전문 가이드 플랫폼
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              NEWSLETTER
            </h4>
            <div className="relative">
              <input
                type="email"
                placeholder="이메일 주소"
                className="w-full bg-transparent border-b border-gray-700 py-3 pr-10 text-sm text-white placeholder-gray-500 focus:border-teal-500 outline-none transition-colors"
              />
              <button className="absolute right-0 top-1/2 -translate-y-1/2 cursor-pointer">
                <i className="ri-arrow-right-line text-gray-400 hover:text-teal-500 transition-colors"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-3">
              최신 인사이트를 이메일로 받아보세요
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              QUICK LINKS
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('insights')}
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm cursor-pointer"
                >
                  Insights
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('library')}
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm cursor-pointer"
                >
                  Library
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('consulting')}
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm cursor-pointer"
                >
                  Consulting
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">
              CONNECT
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-teal-500 transition-colors text-sm"
                >
                  KakaoTalk
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">
              © 2024 Global Career. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-teal-500 transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
